module.exports = __webpack_public_path__ + "img/11.a68e1f37.webp";